import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { Status } from '@app/shared/enums';
import { AngularMaterialModule } from '@app/shared/modules/angular-material.module';
import { DynamicPipe } from '@app/shared/pipes/dynamic-pipe';
import { DriverDataFieldName } from '@app/pages/driver-data/driver-data.constant';

@Component({
  selector: 'app-driver-data-data-grid-cell',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AngularMaterialModule, CommonModule, TranslateModule, DynamicPipe],
  template: `
  @if(data[field] === ''){
    <div></div>
  }
  @else {
    @switch (field) {
      @case (driverDataFieldName.status){
        @if(data[field]===status.INACTIVE) {
        <mat-checkbox disabled [checked]="true"></mat-checkbox>
        }
      }
      @default {
        <div [innerHtml]="data[field] | dynamicPipe: column.pipe: column.pipeArgs"></div>
      }
    }
  }

  `
})
export class DriverDataDataGridCell implements OnInit {
  @Input() data: any;
  @Input() field: string;
  @Input() column: any;

  status = Status;
  driverDataFieldName = DriverDataFieldName;

  constructor() { }

  ngOnInit() { }


}
